import { useContext, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RacingContext } from '../../../Home/RacingPage';
import './RaceSimResultBar.scss';

// const betTypeCount = { WP: 3, WPQ: 3, FCT: 2, TCE: 3, TRI: 3, FF: 4, QTT: 4 };

const RaceSimResultBarInner = () => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [resultStr, setResult] = useState('');

    const context = useContext(RacingContext);
    const content = context.content;
    const { page, raceNo } = content;
    const mtg = content?.meeting;
    const mid = mtg?.id;

    const {
        value: LocalImportanceValue = [],
        setValue: setLocalImportanceValue,
        loaded: localImportanceValueLoaded
    } = context?.RaceSimLocalData ?? {};

    useLayoutEffect(() => {
        if (localImportanceValueLoaded) {
            let localValue = LocalImportanceValue.find((i) => i?.mid === mid);
            if (localValue) {
                let raceData = localValue.para.find((i) => i?.no === raceNo);
                const { result, rsShowPage, showResultBar } = raceData || {};
                if (result && rsShowPage === 'RS_RESULT' && showResultBar) {
                    setResult(result?.split('/')?.slice(0, 4)?.join(','));
                    setIsVisible(true);
                } else {
                    setIsVisible(false);
                }
            } else {
                setIsVisible(false);
            }
        }
    }, [LocalImportanceValue, localImportanceValueLoaded, mid, raceNo]);

    const handleClose = () => {
        if (localImportanceValueLoaded) {
            let localValue = LocalImportanceValue.find((i) => i?.mid === mid);
            if (localValue) {
                let raceData = localValue.para.find((i) => i?.no === raceNo);
                const { result, rsShowPage, showResultBar } = raceData || {};
                if (result && rsShowPage === 'RS_RESULT' && showResultBar) {
                    raceData.showResultBar = false;
                    setLocalImportanceValue([...LocalImportanceValue]);
                }
            }
        }
        setIsVisible(false);
    };

    if (!isVisible || !window.globalConfig.ENABLE_RACE_SIM_BEFORE_2026_CNY_FEATURE) {
        return null;
    }

    return (
        <div className="race-result-bar">
            <div className="race-result-bar__content">
                <span className="race-result-bar__icon" />

                <span className="race-result-bar__label">{t('SIMULATION_RESULT')}:</span>

                <span className="race-result-bar__result">{resultStr}</span>
            </div>

            <button
                type="button"
                className="race-result-bar__close"
                aria-label="Close simulation result"
                onClick={handleClose}
            />
        </div>
    );
};

const RaceSimResultBar = () => {
    const context = useContext(RacingContext);
    const mtg = context?.content?.meeting;
    const mid = mtg?.id;
    return <RaceSimResultBarInner key={mid} />;
};

export default RaceSimResultBar;
